import axios from 'axios';
import { getAuthHeaders, getAuthHeadersWithContentType } from '../utils/auth';

const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL || 'http://localhost:8001';

export interface ModelPrices {
  model_id: number;
  model_name: string;
  provider: string;
  // Активная цена в баллах за единицу по каждому unit_type (строка).
  prices: Record<string, string>;
}

export const getUnitTypes = async (): Promise<string[]> => {
  const response = await axios.get<string[]>(`${ADMIN_API_URL}/admin/unit-types`, {
    headers: await getAuthHeaders(),
  });
  return Array.isArray(response.data) ? response.data : [];
};

export const getModels = async (): Promise<ModelPrices[]> => {
  const response = await axios.get<ModelPrices[]>(`${ADMIN_API_URL}/admin/models`, {
    headers: await getAuthHeaders(),
  });
  return Array.isArray(response.data) ? response.data : [];
};

export const addModel = async (provider: string, modelName: string): Promise<ModelPrices> => {
  const response = await axios.post<ModelPrices>(
    `${ADMIN_API_URL}/admin/models`,
    { provider, model_name: modelName },
    { headers: await getAuthHeadersWithContentType() },
  );
  return response.data;
};

export const updateModelPrices = async (
  modelId: number,
  prices: Record<string, string>,
  note?: string,
): Promise<ModelPrices> => {
  const response = await axios.put<ModelPrices>(
    `${ADMIN_API_URL}/admin/models/${modelId}/prices`,
    { prices, note },
    { headers: await getAuthHeadersWithContentType() },
  );
  return response.data;
};
